import { render, staticRenderFns } from "./FooterUser.vue?vue&type=template&id=0eba641b&scoped=true&"
import script from "./FooterUser.vue?vue&type=script&lang=js&"
export * from "./FooterUser.vue?vue&type=script&lang=js&"
import style0 from "./FooterUser.vue?vue&type=style&index=0&id=0eba641b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eba641b",
  null
  
)

export default component.exports